import CustomerList from '../../../../components/secure/customers/CustomerList'
import { AutoWidthCenter } from '../../../../components/layout/AutoWidthCenter'
import { Button, Heading, HStack } from '@chakra-ui/react'
import { NavLink } from 'react-router-dom'

export default function Customers() {
  return (
    <AutoWidthCenter>
      <HStack pb="5" mt="5" justifyContent="space-between">
        <Heading as="h1">Customers</Heading>
        <Button as={NavLink} to="new">New customer</Button>
      </HStack>
      <CustomerList />
    </AutoWidthCenter>
  );
}